// extracted by mini-css-extract-plugin
export default {"status__wrapper":"styles_status__wrapper__B8rEz","status__name_wrapper":"styles_status__name_wrapper__gTlwX","status__name":"styles_status__name__SeOJV"};